import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { useSchool } from 'features/school';

const LogoImage = styled('img')`
  display: inline-block;
  vertical-align: middle;
  width: inherit;
  height: auto;

  ${(props: any) => {
    return `
        ${props.theme.mediaQueries.mobile} {
          max-height: 26px;
        }

        ${props.theme.mediaQueries.tablet} {
          max-height: 26px;
        }

        ${props.theme.mediaQueries.desktop} {
          max-height: 32px;
        }
      `;
  }}
`;

interface LogoProps {
  dark?: boolean;
  payments?: boolean;
}

const Logo = ({ dark, payments = false, ...props }: LogoProps): ReactElement => {
  const {
    schoolName,
    schoolUuid,
    uiSettings: { logoUrl, logoDarkUrl },
  } = useSchool();

  return (
    <LogoImage
      data-school={schoolUuid === '85338cb1-8075-4dcf-afe2-6ce534dcde27'}
      data-payments={payments}
      src={dark ? logoDarkUrl || logoUrl : logoUrl}
      alt={schoolName}
      title={schoolName}
      {...props}
    />
  );
};

export default Logo;
